import { BookOpen } from "lucide-react";
import JournalEntryCard from "./JournalEntryCard";

const JournalFeed = ({ entries, onDelete, onUpdate }) => {
  if (!entries || entries.length === 0) {
    return (
      <div className="text-center py-12 bg-slate-800/30 rounded-xl border border-dashed border-slate-700">
        <BookOpen size={48} className="mx-auto text-slate-600 mb-4" />
        <h3 className="text-lg font-medium text-slate-400">Your Journal is Empty</h3>
        <p className="text-slate-500 mt-2">Start typing above to create your first entry.</p>
      </div>
    );
  }

  // Group entries by Date string
  const groupedEntries = entries.reduce((groups, entry) => {
    const date = entry.createdAt 
      ? new Date(entry.createdAt).toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' })
      : "Unknown Date";
    
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(entry);
    return groups;
  }, {});

  return (
    <div className="space-y-8 animate-fade-in">
      {Object.entries(groupedEntries).map(([date, dateEntries]) => (
        <div key={date} className="space-y-4">
          
          {/* Date Separator */}
          <div className="flex items-center gap-4">
            <div className="h-px bg-slate-700/50 flex-1"></div>
            <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider bg-slate-900 px-2">
              {date}
            </span>
            <div className="h-px bg-slate-700/50 flex-1"></div>
          </div>

          {/* Cards */}
          <div className="space-y-4">
            {dateEntries.map(entry => (
              <JournalEntryCard
                key={entry.id}
                entry={entry}
                onDelete={onDelete}
                onUpdate={onUpdate}
              />
            ))}
          </div>

        </div>
      ))}
    </div>
  );
};

export default JournalFeed;
